import { createContext, ReactNode, useContext } from 'react'
import { FieldValues, useForm, UseFormReturn } from 'react-hook-form'

// Define the context type
interface ModalWizzarStepsContextType {
  useFormWizzard: UseFormReturn<FieldValues, unknown, FieldValues>
}
const ModalWizardStepsContext = createContext<
  ModalWizzarStepsContextType | undefined
>(undefined)

export const ModalWizzarStepsProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const useFormWizzard = useForm({
    defaultValues: {},
    mode: 'onChange',
  })

  const contextValue: ModalWizzarStepsContextType = {
    useFormWizzard,
  }

  return (
    <ModalWizardStepsContext.Provider value={contextValue}>
      {children}
    </ModalWizardStepsContext.Provider>
  )
}

// Custom hook to use the modal wizard steps context
export const useModalWizardStepsContext = () => {
  const context = useContext(ModalWizardStepsContext)
  if (context === undefined) {
    throw new Error(
      'useModalWizardStepsContext must be used within a ModalWizzarStepsProvider'
    )
  }
  return context
}
